import { intervalToDuration } from 'date-fns'

const MILLISECONDS_PER_SECOND = 1000

/**
 * returns formatted duration from seconds
 */
const getFormattedDurationFromSecond = (SpentSeconds: number) => {
  const { hours, minutes, seconds } = intervalToDuration({
    start: 0,
    end: SpentSeconds * MILLISECONDS_PER_SECOND
  })

  const formatted = [
    `${hours ? `${hours} hour${hours > 1 ? 's' : ''}` : ''}`,
    `${minutes ? `${minutes} minute${minutes > 1 ? 's' : ''}` : ''}`,
    `${seconds ? `${seconds} second${seconds > 1 ? 's' : ''}` : ''}`
  ]
    .filter(Boolean)
    .join(', ')
  return formatted
}

export default getFormattedDurationFromSecond
